import { useCallback } from "react";

export const useLocalStorage = () => {
    const setLocalStorage = useCallback(<T>(key: string, value: T): void => {
        try {
            const serializedValue = JSON.stringify(value);

            localStorage?.setItem(key, serializedValue);
        } catch (error) {
            console.error(`Error storing item with key "${key}" in Local storage:`, error);
        }
    }, []);

    const getLocalStorage = useCallback(<T>(key: string, defaultValue?: T): T | null => {
        try {
            const serializedValue = localStorage?.getItem(key);

            if (serializedValue === null) {
                return defaultValue ?? null;
            }

            return JSON.parse(serializedValue) as T;
        } catch (error) {
            console.error(`Error retrieving item with key "${key}" from Local storage:`, error);

            return defaultValue ?? null;
        }
    }, []);

    const removeLocalStorage = useCallback((key: string): void => {
        try {
            localStorage?.removeItem(key);
        } catch (error) {
            console.error(`Error removing item with key "${key}" from Local storage:`, error);
        }
    }, []);

    const clearLocalStorage = useCallback((): void => {
        try {
            localStorage?.clear();
        } catch (error) {
            console.error("Error clearing Local storage:", error);
        }
    }, []);

    return {
        setLocalStorage,
        getLocalStorage,
        removeLocalStorage,
        clearLocalStorage,
    };
};
